export const getNoBetsErrorMessage = (inGameState, errorMessage, defaultErrorMessage) => inGameState === "live" ? errorMessage : defaultErrorMessage;
//# sourceMappingURL=getNoBetsErrorMessage.js.map